<div class="eui-table__sortable-col-content" (click)="click()">
    <ng-content></ng-content>
    <span *ngIf="!sortDisabled && !order" euiIcon iconClass="eui-table__sortable-icon eui-icon eui-icon-sort" aria-label="No sorting icon"></span>
    <span *ngIf="!sortDisabled && order === 'asc'" euiIcon iconClass="eui-table__sortable-icon eui-icon eui-icon-sort-asc" aria-label="Ascending order icon"></span>
    <span *ngIf="!sortDisabled && order === 'desc'" euiIcon iconClass="eui-table__sortable-icon eui-icon eui-icon-sort-desc" aria-label="Descending order icon"></span>
</div>
